import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, layout, space } from '../../theme/tokens';

export const Container = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  z-index: ${layout.zIndexModal};
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${layout.desktopBreakpoint}) {
    align-items: flex-end;
  }
`;

export const Overlay = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  background: ${layout.overlay};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transition: opacity 250ms ease;
`;

export const Panel = styled.div<{ $open: boolean }>`
  position: relative;
  background: ${colors.white};
  border-radius: ${layout.borderRadiusLg};
  box-shadow: ${layout.shadow};
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  width: ${layout.modalWidth};
  max-width: calc(100vw - ${space[5]});
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transform: ${({ $open }) => ($open ? 'translateY(0)' : `translateY(${space[4]})`)};
  transition: opacity 250ms ease, transform 250ms ease;

  @media (max-width: ${layout.desktopBreakpoint}) {
    width: 100vw;
    max-width: 100vw;
    max-height: 85vh;
    border-radius: ${layout.borderRadiusXl} ${layout.borderRadiusXl} 0 0;
    transform: ${({ $open }) => ($open ? 'translateY(0)' : 'translateY(100%)')};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[5]} ${space[5]} ${space[3]};
  flex-shrink: 0;
`;

export const Title = styled.h2`
  font-family: ${bodyFont};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space[1]};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.fontPrimary};
  font-size: ${fonts.size.xl};
  line-height: 1;
  border-radius: ${layout.borderRadius};
  transition: background 0.15s ease;

  &:hover {
    background: ${colors.lighterGrey};
  }
`;

export const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 ${space[5]};
`;

export const Footer = styled.div`
  flex-shrink: 0;
  border-top: 1px solid ${colors.lighterGrey};
`;
